var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27686 37.6808V20.6402C5.27686 17.8593 6.38331 15.1671 8.4187 12.9898C10.4541 10.8183 13.2942 9.29174 16.4774 8.66455",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4892 11.2153C17.4892 11.2153 17.1224 20.7474 5.27686 26.4867",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9086 37.6818C11.3998 32.9896 10.7135 27.9603 10.9028 22.9192",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.848 37.6808V20.6402C37.848 17.8593 36.7415 15.1671 34.7062 12.9898C32.6709 10.8183 29.8306 9.29174 26.6475 8.66455",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6304 11.2153C25.6304 11.2153 25.9973 20.7474 37.8428 26.4867",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2158 37.6818C31.7246 32.9896 32.4111 27.9603 32.2217 22.9192",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 38.0183H29.1983",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1982 38.0183H39.3752",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7138 9.55313C16.986 10.1152 17.3706 10.5708 17.7137 10.9436C18.335 11.6299 19.0451 12.2394 19.7255 12.831C20.0922 13.1446 20.4592 13.4642 20.8141 13.7955C21.0449 14.0144 21.2994 14.1209 21.5596 14.1209C21.8201 14.1209 22.0803 14.0144 22.3289 13.7896C23.0094 13.1801 23.6838 12.5766 24.3582 11.9672C25.0625 11.3282 25.5772 10.772 25.9974 10.204C26.5002 9.51762 26.7132 8.76619 26.6364 7.9615C26.5535 7.10355 26.1275 6.44678 25.4056 6.0622C24.1098 5.37584 22.5832 5.51192 21.542 6.36987C20.7431 5.70719 19.7373 5.47643 18.6249 5.72494C17.8261 5.89652 17.2463 6.25744 16.8617 6.81362C16.6487 7.12131 16.5599 7.45264 16.4889 7.71298L16.4712 8.70702L16.5008 8.89635C16.5422 9.09162 16.6014 9.32237 16.7138 9.55313Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArch);
export default __webpack_public_path__ + "static/media/navigation-arch.4b68cf35.svg";
export { ForwardRef as ReactComponent };